import Vue from "vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const basicDate = (date: string) => {
  if (!date) {
    return null;
  }
  return dayjs(date).format("YYYY-MM-DD");
};

export const basicDateUtc = (date: string) => {
  if (!date) {
    return null;
  }
  return dayjs.utc(date).format("YYYY-MM-DD");
};

export const basicDateTime = (date: string) => {
  if (!date) {
    return null;
  }
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
};

export const basicDateTimeZone = (date: string) => {
  if (!date) {
    return null;
  }
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss Z");
};

Vue.filter("basicDate", basicDate);
Vue.filter("basicDateUtc", basicDateUtc);
Vue.filter("basicDateTime", basicDateTime);
Vue.filter("basicDateTimeZone", basicDateTimeZone);
